export default __webpack_public_path__ + "static/media/neville.adf9a376.jpeg";